<template>

  <ControlloPagamenti />

</template>

<script>
import ControlloPagamenti from '../components/pratiche/estratticonto/ControlloPagamenti.vue'

export default {
  pageName: 'controllo-pagamenti',
  components: {
    ControlloPagamenti
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
}
</script>
